<template>
<fieldset :disabled="loading">
    <div class="layout">
        <div class="items">
            <div class="items-title">{{translate('draftSignatureLocation.signers')}}</div>
            <div style="position: fixed; z-index: 99999; top: 44px;">
                <div class="btn-group" role="group" style="border-radius:0; width:149px;">
                    <button class="btn btn-outline-info" type="button" @click="addSigner" style="border-radius:0;" :title="translate('draftSignatureLocation.addSigner')" :disabled="!this.isNotEnoughSignatureLocation">{{translate('add')}}</button>
                    <button class="btn btn-outline-info" type="button" @click="removeSigner" style="border-radius:0;" :title="translate('draftSignatureLocation.removeSigner')">{{translate('remove')}}</button>
                </div>
            </div>
        </div>
        <div class="preview">
            <!-- İmzalar -->
            <vue-draggable-resizable v-for="(sl, i) in document.SignatureLocations" :key="sl.Key"
                @dragstop="(x, y) => onDragStop(sl, x, y)"
                @activated="selectedTextLocation = null; selectedSignatureLocation = sl;"
                @resizing="(x, y, w, h) => { sl.Width = w, sl.Height = h, sl.X = x, sl.Y = y }"
                :minWidth="100"
                :minHeight="30"
                :maxWidth="500"
                :maxHeight="500"
                :x="sl.X"
                :y="sl.Y"
                :w="sl.Width"
                :h="sl.Height"
                :grid="[5, 5]"
                :handles="['br']"
                :resizable="sl.X >= 0" 
                v-show="sl.Page == 0 || sl.Page == page"
                
                class="signature">
                <div class="remove" :title="translate('remove')" v-show="sl.X >= 0" @click.prevent="resetSignature(document.SignatureLocations[i])"></div>
                <div v-if="sl.Signer" :title="sl.Text">{{sl.Signer.FullName}}</div>
                <div v-else :title="sl.Text">{{sl.Text}}</div>
            </vue-draggable-resizable>

            <!-- QR Code -->
            <vue-draggable-resizable name="qrcode" 
                v-show="!hasSignature && (document.QrCodeLocation.Page == 0 || document.QrCodeLocation.Page == page || document.QrCodeLocation.PrintToAllPages)"
                :key="document.QrCodeLocation.Key"
                @dragstop="(x, y) => onDragStop(document.QrCodeLocation, x, y)"
                @resizing="(x, y, w, h) => onResize(document.QrCodeLocation, w)"
                :x="document.QrCodeLocation.X"
                :y="document.QrCodeLocation.Y"
                :w="document.QrCodeLocation.Size"
                :h="document.QrCodeLocation.Size"
                :min-width="40"
                :max-width="150"
                :grid="[5, 5]"
                :handles="['br']"
                :resizable="document.QrCodeLocation.X >= 0"
                :lock-aspect-ratio="true"
                class="qrcode">
                <div class="remove" title="Kaldır" v-show="document.QrCodeLocation.X >= 0" @click="resetQrCode()"></div>
            </vue-draggable-resizable>

            <!-- Metinler -->
            <vue-draggable-resizable v-for="sl in document.TextLocations" :key="sl.Id"
                @activated="selectedSignatureLocation = null; selectedTextLocation = sl"
                @dragstop="(x, y) => onDragStop(sl, x, y)"
                :x="sl.X"
                :y="sl.Y"
                :h="15"
                :w="'auto'"
                :resizable="false"
                :grid="[5, 5]"
                v-show="!hasSignature && (sl.Page == 0 || sl.Page == page || sl.PrintToAllPages)"
                class="pdftext">
                <div class="remove" title="Kaldır" v-show="sl.X >= 0" @click="removeText(sl)"></div>
                <div>{{sl.Text}}</div>
            </vue-draggable-resizable>

            <!-- Sayfa önizleme resmi -->
            <img ref="preview" onselectstart="return false" ondragstart="return false" v-show="!loading" class="preview-image" />
            <div v-show="loading" class="text-muted" style="padding:50px;">
                {{page}}. {{translate('draftSignatureLocation.pagePreviewPreparing')}}
            </div>
        </div>
        <div class="details">
            <div>
                <div class="row">
                    <div class="col">
                        <div style="font-weight:bold;">{{translate('draftSignatureLocation.applyLocationPattern')}}: {{isNotEnoughSignatureLocation}}</div>
                        <select class="form-control" v-model="selectedTemplateId">
                            <option :value="null">{{translate('draftSignatureLocation.newPattern')}}</option>
                            <option v-for="t in templates" :key="t.Id" :value="t.Id">
                                {{t.Name}}
                                <template v-if="t.IsDefault">({{translate('draftSignatureLocation.default')}})</template>
                                <template v-if="hasAuth('Admin') && t.User">({{t.User.FullName}})</template>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row" style="margin-top:8px;">
                    <div class="col">
                        <div class="btn-group btn-group-sm btn-block">
                            <button class="btn btn-outline-primary" type="button" :title="translate('save')" @click="saveTemplate">
                                {{translate('save')}}
                            </button>
                            <button :disabled="!selectedTemplate || selectedTemplate.IsDefault" class="btn btn-outline-secondary" type="button" :title="translate('draftSignatureLocation.setDefaultText')" @click="setAsDefault">
                                {{translate('draftSignatureLocation.setDefault')}}
                            </button>
                            <button class="btn btn-outline-danger" :disabled="!selectedTemplate" type="button" :title="translate('remove')" @click="removeTemplate(selectedTemplate)">
                                {{translate('remove')}}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top:8px;">
                    <div class="col">
                        <button class="btn btn-sm btn-block btn-outline-secondary" @click="applyToAllDocuments()" type="button">{{translate('draftSignatureLocation.applyToAllDocuments')}}</button>
                    </div>
                </div>
                <hr/>
                <div>
                    <label >
                        <input type="checkbox" v-model="document.QrCodeLocation.PrintToAllPages" :value="true" :disabled="document.QrCodeLocation.X < 0"> {{translate('draftSignatureLocation.placeQRCodeToAllPages')}}
                    </label>
                </div>
                <div>
                    <div class="btn-group" role="group">
                        <button @click="addTextDrop = !addTextDrop" type="button" class="btn btn-secondary dropdown-toggle" :disabled="hasSignature">
                            {{translate('draftSignatureLocation.addText')}}
                        </button>
                        <div class="dropdown-menu" style="display:block" v-if="addTextDrop">
                            <a class="dropdown-item" href="#void" @click.prevent="addText('Dogrulama kodu: {ValidationCode}', true)">{{translate('draftSignatureLocation.addTextDropdown.validationCode')}}</a>
                            <a class="dropdown-item" href="#void" @click.prevent="addText('{ValidationURL}', true)">{{translate('draftSignatureLocation.addTextDropdown.validationUrl')}}</a>
                            <a class="dropdown-item" href="#void" @click.prevent="addText('* Bu belge 5070 sayili elektronik imza kanunu kapsaminda E-IMZA ile imzalanmistir. *', true)">{{translate('draftSignatureLocation.addTextDropdown.5070Text')}}</a>
                            <a class="dropdown-item" href="#void" @click.prevent="addText('Özel...')">{{translate('draftSignatureLocation.addTextDropdown.special')}}</a>
                        </div>
                    </div>
                </div>
                <div v-if="selectedTextLocation" style="padding:15px 15px 0 0">
                    <textarea v-model="selectedTextLocation.Text" @keydown.enter.prevent="false" class="form-control" style="height:150px; resize:none;" :readonly="selectedTextLocation.ReadOnly"></textarea>
                    <label >
                        <input type="checkbox" v-model="selectedTextLocation.PrintToAllPages" :value="true"> {{translate('draftSignatureLocation.placeTextToAllPages')}}
                    </label>
                </div>
                <div class="alert alert-danger" v-if="isNotEnoughSignatureLocation">
                    {{translate('warnings.notEnoughSignatureLocation')}}
                </div>
                <div class="alert alert-warning" v-if="hasSignature">
                    {{translate('warnings.justSignatureLocation')}}
                </div>
            </div>
        </div>
        <div class="commands">
            <div style="max-width:580px">
                <button type="button" class="btn btn-success float-right"  @click.prevent="close()">{{translate('okay')}}</button>
                <label class="float-left" style="padding:8px">{{translate('page')}}</label>
                <nav>
                    <ul class="pagination">
                        <li class="page-item" :class="{'disabled' : page <= 1 }">
                            <button class="page-link" href="#" @click.prevent="page-=1;">&laquo;</button>
                        </li>
                        <li style="margin-left:-1px;">
                            <select v-model="page" class="form-control">
                                <option v-for="(p, index) in new Array(pageCount)" :key="index" :value="index+1">
                                    {{index+1}}
                                </option>
                            </select>
                        </li>
                        <li class="page-item" :class="{'disabled' : page >= pageCount}">
                            <button type="button" class="page-link" href="#" @click.prevent="page+=1;">&raquo;</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</fieldset>
</template>

<script>
import axios from 'axios'
import VueDraggableResizable from 'vue-draggable-resizable'
// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
    components: {
        VueDraggableResizable
    },
    props: {
        draft: Object,
        document:{
            type:Object,
            required: true
        },
        page: {
            type:Number,
            default:1
        }
    },
    data(){
        return {
            pageCount: 1,
            loading: false,
            addTextDrop: false,
            selectedTextLocation: null,
            selectedSignatureLocation: null,
            templates: null,
            selectedTemplateId: null,
            hasSignature:false
        }
    },
    watch: {
        page(){
            //console.log('Page değişti:', this.page);
            this.getPreview();
        },
        selectedTemplateId(){
            this.applyTemplate(this.selectedTemplate);
        }
    },
    created(){
        this.checkSignatureExist();
        console.log("aa",this.hasSignature)
        document.getElementsByTagName('body')[0].style = 'overflow:hidden';
        this.getPreview();
        this.getTemplates();
    },
    destroyed(){
        document.getElementsByTagName('body')[0].style = '';
    },
    computed: {
        selectedTemplate(){
            return this.templates?.filter(x => x.Id == this.selectedTemplateId)[0];
        },
        signers(){
            var result = [];
            this.draft.Steps.forEach(step => {
                if(step.Action === "Sign"){
                    step.ApprovalAuthorities.forEach(aa => {
                        result.push({ FullName: aa.FullName });
                    })
                }
            });
            return result;
        },
        isNotEnoughSignatureLocation(){
            return this.document.SignatureLocations.length < this.signers.length;
        }
    },
    methods: {
        checkSignatureExist(){
        axios.get(`/draft/HasPdfSignature/?id=${this.draft.Id}&documentId=${this.document.Id}`)
            .then(x => {
                console.log('checkSignatureExist', x);
                console.log('checkSignatureExist', x.data.Data.signatureExist);
                this.hasSignature =  x.data.Data.signatureExist;
            })
            .catch(x => {
                window.processErrorResponse(x, this);
            })
            .finally(() => {
                this.loading = false;
            });
            return false;
    },
        addSigner(){
            if(!this.document.SignatureLocations)
                this.document.SignatureLocations = [];

            if(this.isNotEnoughSignatureLocation)
                this.document.SignatureLocations.push({ X: -1, Y: -1, Page: this.Page, Key: Math.random() });

            this.initializeLocations();
        },
        removeSigner(){
            this.document.SignatureLocations.pop();
        },
        setAsDefault(){
            if(!this.selectedTemplate)
                return;

            if(confirm(this.translate('draftSignatureLocation.templateToDefault:'+this.selectedTemplate.Name))) {
                this.loading = true;
                axios.post('/locationTemplate/setasdefault/' + this.selectedTemplate.Id, {})
                .then(x => {
                    console.log('templates: ', x);
                    this.templates = x.data;
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                })
                .finally(() => {
                    this.loading = false;
                });
            }
        },
        removeTemplate(template) {
            if(template == null)
                return;

            if(confirm(this.translate('draftSignatureLocation.templateToDelete:'+this.selectedTemplate.Name))) {
                this.loading = true;
                axios.post('/locationTemplate/delete/' + this.selectedTemplate.Id, {})
                .then(x => {
                    console.log('templates: ', x);
                    this.selectedTemplateId = null;
                    this.getTemplates();
                })
                .catch(x => {
                    this.loading = false;
                    window.processErrorResponse(x, this);
                });
            }
        },
        applyTemplate(template) {
            if(!template)
                return;

            this.document.QrCodeLocation = template.QrCodeLocation;
            this.document.TextLocations = template.TextLocations;
            this.document.SignatureLocations = template.SignatureLocations;
            this.initializeLocations();
        },
        applyToAllDocuments(){
            if(!confirm(this.translate('draftSignatureLocation.willApplyToAllDocs')))
                return;

            for(var d in this.draft.Documents){
                var doc = this.draft.Documents[d];
                doc.QrCodeLocation = this.document.QrCodeLocation;
                doc.TextLocations = this.document.TextLocations;
                doc.SignatureLocations = this.document.SignatureLocations;
            }

            console.log('Draft: ', this.draft);
            alert(this.translate('messages.success'));
        },
        getTemplates(){
            this.loading = true;
            axios.post('/locationTemplate/get', {})
            .then(x => {
                console.log('templates: ', x);
                this.templates = x.data.Result;
            })
            .catch(x => {
                window.processErrorResponse(x, this);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        saveTemplate() {
            var template = null;
            if(this.selectedTemplateId)
                template = this.selectedTemplate;

            if(template == null)
            {
                do {
                    var newTemplateName = prompt(this.translate('draftSignatureLocation.enterTemplateName'), this.translate('draftSignatureLocation.newPattern'));
                } while(newTemplateName == "");
                
                if(newTemplateName == null)
                    return;

                template = { Name : newTemplateName };
            }

            template.QrCodeLocation = this.document.QrCodeLocation;
            template.TextLocations = this.document.TextLocations;
            template.SignatureLocations = this.document.SignatureLocations;
            template.IsActive = true;

            this.loading = true;
            axios.post('/locationTemplate/post', template)
            .then(x => {
                console.log('save result: ', x);
                var index = this.templates.indexOf(this.selectedTemplate);
                if(index < 0)
                    this.templates.push(x.data);
                else
                    this.templates[index] = x.data;
            })
            .catch(x => {
                console.log('Save failed: ', x);
                window.processErrorResponse(x, this);
            })
            .finally(() => {
                this.loading = false;
            })
        },
        close(){
            this.$emit('close', this.document);
        },
        onDragStop(sl, x, y){
            console.log('dragstop');

            sl.X = x;
            sl.Y = y;
            sl.Page = this.page;

            if(sl.X < 0)
                sl.Key = Math.random();

            this.initializeLocations();
        },
        onResize(qr, size) {
            qr.Size = size;
        },
        resetSignature(sl){
            //this.document.SignatureLocations = this.document.SignatureLocations.filter(x => x.Id != sl.Id);
            console.log('Reset signature');
            sl = this.document.SignatureLocations.filter(x => x.Key == sl.Key)[0];


            sl.X = -1;
            sl.Y = -1;
            //sl.Key = Math.random();
            this.initializeLocations();
        },
        resetQrCode(){
            this.document.QrCodeLocation = {
                Page:0,
                X: -145,
                Y: 80,
                Size: 100,
            };
            this.initializeLocations();
        },
        getPreview(){
            this.loading = true;
            axios({
                url: '/draft/thumbnail', //your url
                method: 'POST',
                data: {
                    DraftId: this.draft.Id,
                    DocumentId: this.document.Id,
                    Page : this.page ?? 1
                },
            }).then((response) => {
                this.$refs.preview.src = 'data:image/jpg;base64,' + response.data.image;
                this.page = response.data.page;
                this.pageCount = response.data.pageCount;
                this.loading = false;
            });

            this.initializeLocations();
        },
        initializeLocations(){
            //console.log(this.draft);
            var signers = this.signers;

            if(!this.document.SignatureLocations) {
                this.document.SignatureLocations = signers.map(() => {
                     var sl = { X: -1, Y: -1, Page: 0, Key: Math.random() };
                     return sl;
                });
            }
                

            var top = 80;

            if(!this.document.QrCodeLocation || this.document.QrCodeLocation.X < 0) {
                this.document.QrCodeLocation = {
                    Page:0,
                    X: -145,
                    Y: 80,
                    Size: 100,
                };
                top = this.document.QrCodeLocation.Y + this.document.QrCodeLocation.Size + 20;
            }

            if(!this.document.QrCodeLocation.Key)
                this.document.QrCodeLocation.Key = Math.random();

            

            var notPositionedSignatureLocationCount = 0;


            for(var i = 0; i < this.document.SignatureLocations.length; i++) {
                var sl = this.document.SignatureLocations[i];

                if(!sl.Key)
                    sl.Key = Math.random();

                sl.Text = (i + 1) + ". İmzacı";
                sl.Signer = signers[i];

                if(sl.X < 0) {
                    sl.X = -160;
                    sl.Y = (notPositionedSignatureLocationCount * 45) + top;
                    sl.Width = 130;
                    sl.Height = 35;
                    sl.Page = 0;
                    notPositionedSignatureLocationCount++;
                }
            }

            console.log('initializeLocations:', this.document.SignatureLocations);

            this.$forceUpdate();
        },
        addText(text, readonly){
            this.addTextDrop = false;

            var tl = {
                X: 100,
                Y:100,
                Page: this.page,
                Text: text,
                ReadOnly: readonly,
            };

            if(!this.document.TextLocations)
                this.document.TextLocations = [];

            this.document.TextLocations.push(tl);
        },
        removeText(tl) {
            this.document.TextLocations = this.document.TextLocations.filter(x => x != tl);
            this.selectedTextLocation = null;
        }
    }
}
</script>
<style scoped>
    .pdftext{
        color:red;
        font-size: 8px;
        font-weight: bold;
        cursor:grab;
        border: 1px dashed rgba(1, 1, 1, 0.2) !important;
    }

    .pdftext div {
        white-space: nowrap;
        overflow: hidden;
    }

    .qrcode {
        cursor:grab;
        background-image: url('../assets/qrcode.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .signature {
        color:red;
        font-size: 8px;
        font-weight: bold;
        cursor:grab;
        padding-top:6px;
        border: 1px dashed rgba(1, 1, 1, 0.2) !important;
    }

    .signature:hover,
    .signature:active
    {
        background-color: rgba(1, 1, 1, 0.2);
        border: 1px dashed rgba(1, 1, 1, 0.7) !important;
    }

    .signature div {
        height: 22px;
        overflow: hidden;
    }

    .signature:active{
        cursor:grabbing;
    }

    a.close {
        position: fixed;
        width:30px;
        height: 30px;
        right:0;
        top:0;
        background: red;
        z-index: 99999;
    }

    .layout {
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: #FFF;
        z-index: 10000;
        overflow: auto;
    }

    .items {
        position: absolute;
        left:0;
        top:0;
        height:1000px;
        width:150px;
        border-right: 1px solid #DDD;
    }

    .items-title {
        padding: 10px;
        text-align: center;
        background-color:#17a2b8;
        color: #FFF;
        font-weight:bold;
        position: fixed;
        z-index: 99999;
        width:149px;
    }

    .preview {
        position: absolute;
        left:150px;
        top:0;
        height:1000px;
        right: 0;
        background: #F1F1F1;
        padding: 20px;
    }

    .preview .preview-image {
        user-select: none;
        -webkit-box-shadow: 0px 0px 13px 2px rgba(0,0,0,0.39);
        -moz-box-shadow: 0px 0px 13px 2px rgba(0,0,0,0.39);
        box-shadow: 0px 0px 13px 2px rgba(0,0,0,0.39);
    }

    .preview .remove {
        width:25px;
        height:25px;
        position:absolute;
        top:-15px;
        left:calc(100% - 12px); top:-15px;
    }

    .details {
        position: fixed;
        top:0;
        right: 0;
        bottom: 0;
        width:300px;
        padding: 10px;
        background-color: #FFF;
        border-left: 1px solid #DDD;
    }

    .commands {
        position: fixed;
        left:149px;
        padding: 8px;
        bottom:0;
        right:0;
        height:56px;
        border-top:1px solid #DDD;
        background: #FFF;
    }
</style>